// Çevrimdışı POS satış kuyruğu — internet kesildiğinde satışlar localStorage'a alınır,
// bağlantı gelince backend'e (idempotent client_tx_id ile) eşitlenir.
const KEY = "groot_offline_sales";
const SEQ = "groot_offline_seq";

export const QUEUE_STORAGE_ERROR = "Çevrimdışı kayıt alanı okunamıyor veya yazılamıyor. Kayıtlar otomatik silinmedi. Bu cihazın site verilerini temizlemeyin.";
const read = () => {
  try {
    const raw = localStorage.getItem(KEY);
    const arr = raw === null ? [] : JSON.parse(raw);
    if (!Array.isArray(arr) || arr.some((item) => !item || typeof item !== "object" ||
      typeof item.client_tx_id !== "string" || !item.client_tx_id ||
      !item.payload || typeof item.payload !== "object" || Array.isArray(item.payload))) throw new Error();
    return arr;
  } catch { throw new Error(QUEUE_STORAGE_ERROR); }
};
const write = (arr) => localStorage.setItem(KEY, JSON.stringify(arr));

export const newTxId = () => `tx_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;

export const nextOfflineNo = () => {
  read(); // Okunamayan kuyruğun satış numarasını tüketmesine izin verme.
  const seq = (parseInt(localStorage.getItem(SEQ) || "0", 10) || 0) + 1;
  localStorage.setItem(SEQ, String(seq));
  return `ÇDK-${String(seq).padStart(4, "0")}`;
};

export const enqueueSale = (item) => {
  const a = read();
  a.push(item);
  write(a);
  return a.length;
};

export const getQueue = () => read();
export const queueCount = () => read().length;

export const removeSale = (clientTxId) => {
  const a = read().filter((x) => x.client_tx_id !== clientTxId);
  write(a);
  return a.length;
};

export const isNetworkError = (err) =>
  !err?.response || err.code === "ERR_NETWORK" || err.message === "Network Error";

// Eşitleme geçmişi (son 20 kayıt) — kasiyere görünürlük için
const LOG = "groot_offline_synclog";
export const logSync = (entry) => {
  let arr = [];
  try { arr = JSON.parse(localStorage.getItem(LOG)) || []; } catch { arr = []; }
  arr.unshift({ at: new Date().toISOString(), ...entry });
  localStorage.setItem(LOG, JSON.stringify(arr.slice(0, 20)));
};
export const getSyncLog = () => {
  try { return JSON.parse(localStorage.getItem(LOG)) || []; } catch { return []; }
};
